import { SPACING_L_L, SPACING_L_M, SPACING_L_S, SPACING_L_XL, SPACING_L_XXL, SPACING_M_L, SPACING_M_M, SPACING_M_S, SPACING_M_XL, SPACING_M_XXL, SPACING_S_L, SPACING_S_M, SPACING_S_S, SPACING_S_XL, SPACING_S_XXL, SPACING_XL_L, SPACING_XL_M, SPACING_XL_S, SPACING_XL_XL, SPACING_XL_XXL, SPACING_XS_L, SPACING_XS_M, SPACING_XS_S, SPACING_XS_XL, SPACING_XS_XS, SPACING_XS_XXL, SPACING_XXL_L, SPACING_XXL_M, SPACING_XXL_S, SPACING_XXL_XL, SPACING_XXL_XXL, SPACING_XXS_L, SPACING_XXS_M, SPACING_XXS_S, SPACING_XXS_XL, SPACING_XXS_XS, SPACING_XXS_XXL, SPACING_XXXL_L, SPACING_XXXL_M, SPACING_XXXL_S, SPACING_XXXL_XL, SPACING_XXXL_XXL, PAGE_MARGIN_L, PAGE_MARGIN_M, PAGE_MARGIN_S, PAGE_MARGIN_XL, PAGE_MARGIN_XS, PAGE_MARGIN_XXL } from '@audi/audi-ui-design-tokens';
export var responsiveSpacingTokens = {
  xxs: {
    xs: SPACING_XXS_XS,
    s: SPACING_XXS_S,
    m: SPACING_XXS_M,
    l: SPACING_XXS_L,
    xl: SPACING_XXS_XL,
    xxl: SPACING_XXS_XXL
  },
  xs: {
    xs: SPACING_XS_XS,
    s: SPACING_XS_S,
    m: SPACING_XS_M,
    l: SPACING_XS_L,
    xl: SPACING_XS_XL,
    xxl: SPACING_XS_XXL
  },
  s: {
    xs: SPACING_S_S,
    s: SPACING_S_S,
    m: SPACING_S_M,
    l: SPACING_S_L,
    xl: SPACING_S_XL,
    xxl: SPACING_S_XXL
  },
  m: {
    xs: SPACING_M_S,
    s: SPACING_M_S,
    m: SPACING_M_M,
    l: SPACING_M_L,
    xl: SPACING_M_XL,
    xxl: SPACING_M_XXL
  },
  l: {
    xs: SPACING_L_S,
    s: SPACING_L_S,
    m: SPACING_L_M,
    l: SPACING_L_L,
    xl: SPACING_L_XL,
    xxl: SPACING_L_XXL
  },
  xl: {
    xs: SPACING_XL_S,
    s: SPACING_XL_S,
    m: SPACING_XL_M,
    l: SPACING_XL_L,
    xl: SPACING_XL_XL,
    xxl: SPACING_XL_XXL
  },
  xxl: {
    xs: SPACING_XXL_S,
    s: SPACING_XXL_S,
    m: SPACING_XXL_M,
    l: SPACING_XXL_L,
    xl: SPACING_XXL_XL,
    xxl: SPACING_XXL_XXL
  },
  xxxl: {
    xs: SPACING_XXXL_S,
    s: SPACING_XXXL_S,
    m: SPACING_XXXL_M,
    l: SPACING_XXXL_L,
    xl: SPACING_XXXL_XL,
    xxl: SPACING_XXXL_XXL
  },
  pageMargin: {
    xs: PAGE_MARGIN_XS,
    s: PAGE_MARGIN_S,
    m: PAGE_MARGIN_M,
    l: PAGE_MARGIN_L,
    xl: PAGE_MARGIN_XL,
    xxl: PAGE_MARGIN_XXL
  }
};
export var spacingLabels = Object.keys(responsiveSpacingTokens);